import * as Sentry from "@sentry/react";

import { isChunkLoadError } from "./chunkReload";

export function initSentry(): void {
  const dsn = import.meta.env.VITE_SENTRY_DSN;
  if (!dsn) return;
  Sentry.init({
    dsn,
    environment: import.meta.env.MODE,
    tracesSampleRate: 0.1,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0,
    beforeSend(event, hint) {
      // POL-1: Chunk-Load-Fehler nach Deploy sind kein Code-Bug (alter Hash
      // weg) — sie werden durch kontrollierten Reload behandelt, nicht als
      // Sentry-Issue gemeldet. Alle anderen Fehler laufen unveraendert durch.
      if (isChunkLoadError(hint?.originalException)) return null;
      return event;
    },
  });
}
